<template>
  <Table :rows="rows" :columns="columns" :columnID="'idOrden'" table-class="table-hover">
    <template #headactions>
      <button class="btn btn-xs btn-icon btn-light-success" @click="onNew">
        <i class="fa fa-plus"></i>
      </button>
    </template>
    <template #rows="{ rows: bodyRows }">
      <OrdenDeServicioRow v-for="row in bodyRows" :key="row.idOrden" :item="row" @store="$emit('store')"></OrdenDeServicioRow>
    </template>
  </Table>
</template>

<script>
import OrdenDeServicioRow from "./OrdenDeServicioRow.vue";
import Table from "../../shared/components/Table.vue";
import { mapGetters } from "vuex";
export default {
  components: { Table, OrdenDeServicioRow },
  props: {
    rows: Array,
  },
  computed: {
    columns() {
      return [
        {
          key: "actions",
          label: "",
          width: 105,
          head_class: "text-center",
        },
        {
          key: "codigo",
          label: "Código",
          width: 65,
          head_class: "text-center",
        },
        {
          key: "fecha",
          width: this.hayEditables ? 80 : 60,
          head_class: "text-center",
        },
        {
          key: "servicio",
          width: 150,
        },
        {
          key: "horaSalida",
          label: "Salida",
          width: 45,
          head_class: "text-center",
        },
        {
          key: "idioma",
          key: "Idi.",
          width: 35,
          head_class: "text-center",
        },
        {
          key: "registros",
          key: "Reg.",
          width: 35,
          head_class: "text-center",
        },
        {
          key: "nroAdultos",
          label: "PAX",
          width: 35,
          head_class: "text-center",
        },
        {
          key: "nroNinos",
          label: "CHD",
          width: 35,
          head_class: "text-center",
        },
        {
          key: "vehiculo",
          label: "Vehículo",
          width: 130,
        },
        {
          key: "conductor",
          width: 130,
        },
        {
          key: "contactoConductor",
          label: "Contacto",
          width: 75,
        },
        {
          key: "guia",
          label: "Guía",
          width: 130,
        },
        {
          key: "asistente",
          width: 130,
        },
        {
          key: "transfer",
          width: 100,
        },
        {
          key: "observacion",
          key: "Observación",
          width: 130,
        },
        {
          key: "awanacancha",
          key: "Awan.",
          width: 45,
          head_class: "text-center",
        },

        {
          key: "usuarioCreador",
          key: "U.C.",
          width: 50,
          head_class: "text-center",
        },
        {
          key: "usuarioModificador",
          key: "U.M.",
          width: 50,
          head_class: "text-center",
        },
      ];
    },
    ...mapGetters("ordenesDeServicio", ["hayEditables"]),
  },
  methods: {
    onNew() {
      this.$store.dispatch("ordenesDeServicio/newItem");
    },
  },
};
</script>

<style></style>
